import { Box, DuoColorIcon, Icon } from '@zillow/constellation-10';
import { IconChecklistFilled, IconFileFilled, IconShieldCheckmarkFilled } from '@zillow/constellation-icons';
import { ActiveCardSkeleton } from './ActiveCardSkeleton';

export const DocumentsSkeleton = () => {
  return (
    <Box
      css={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: { base: '1fr', md: '1fr', lg: 'repeat(3, 1fr)' },
        gridAutoRows: '1fr',
        gap: 'loose',
      }}
      data-testid="DocumentsSkeleton"
    >
      <ActiveCardSkeleton
        icon={
          <DuoColorIcon tone="info" css={{ opacity: 0.3 }}>
            <Icon>
              <IconFileFilled />
            </Icon>
          </DuoColorIcon>
        }
      />
      <ActiveCardSkeleton
        icon={
          <DuoColorIcon tone="info" css={{ opacity: 0.3 }}>
            <Icon>
              <IconChecklistFilled />
            </Icon>
          </DuoColorIcon>
        }
      />
      <ActiveCardSkeleton
        icon={
          <DuoColorIcon tone="info" css={{ opacity: 0.3 }}>
            <Icon>
              <IconShieldCheckmarkFilled />
            </Icon>
          </DuoColorIcon>
        }
      />
    </Box>
  );
};
